import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getToken, setToken, clearToken, isAuthenticated } from '../utils/auth';
import { fetchUserDetails } from '../api';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState({
        loggedIn: isAuthenticated(),
        details: null,
        loading: true,
        justLoggedOut: false
    });

    const updateUserState = useCallback((token, userDetails) => {
        setToken(token);
        setUser({
            loggedIn: true,
            details: userDetails,
            loading: false,
            justLoggedOut: false
        });
        console.log('UserContext: User state updated', { token, userDetails });
    }, []);

    const login = useCallback(async (token, initialUserDetails) => {
        setUser(prevUser => ({ ...prevUser, loading: true, justLoggedOut: false }));
        setToken(token);  // Store the token immediately
        try {
            const response = await fetchUserDetails(token);  // Pass the token explicitlyi
            console.log ('user context data: ', response);
            updateUserState(token, response.data);
        } catch (error) {
            console.error("Failed to fetch complete user details during login:", error);
            clearToken();
            setUser({
                loggedIn: false,
                details: null,
                loading: false,
                justLoggedOut: false
            });
        }
    }, [updateUserState]);

    const logout = useCallback(() => {
        clearToken();
        setUser({
            loggedIn: false,
            details: null,
            loading: false,
            justLoggedOut: true  // Set this flag to true on logout
        });
        console.log('UserContext: User logged out');
    }, []);

    useEffect(() => {
        const token = getToken();
        if (token) {
            login(token);
        } else {
            setUser(prevUser => ({ ...prevUser, loading: false }));
        }
    }, [login]);

    return (
        <UserContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </UserContext.Provider>
    );
};